module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"header-actions":"Aktionen","no-data-msg":"Es wurden keinen Einträge gefunden","search-field-label":"Suchen"},"fr":{"header-actions":"Actions","no-data-msg":"Aucun résultat n\u0027a été trouvé","search-field-label":"Chercher"},"it":{"header-actions":"Azioni","no-data-msg":"Non è stato trovato nessuna registrazione","search-field-label":"Ricerca"}}')
  delete Component.options._Ctor
}
